import { Component } from '@angular/core';

import  { AppHeaderPopoverController } from '../app-header-popover/app-header-popover';

@Component({
  selector: 'app-header',
  templateUrl: 'app-header.html'
})
export class AppHeaderComponent {
  constructor(public appHeaderPopover:AppHeaderPopoverController) {}
    presentPopover(event) {
    	this.appHeaderPopover.present(event);
  }
}



// WEBPACK FOOTER //
// ./src/components/app-header/app-header.ts